import { AxiosPromise } from 'axios';
import { PartnerUser } from 'features/users/ts/PartnerUser';
import { api } from 'api';

export const getProfileRequest = (): AxiosPromise<PartnerUser> => api.get(`/profiles/profile/`);

export const editProfileRequest = (user: Partial<PartnerUser>): AxiosPromise<PartnerUser> => {
  return api.patch(`/profiles/profile/edit/`, user);
};
